export default __webpack_public_path__ + "static/media/logo-nocircle.f59684b9.png";